import { z } from 'zod/v4';
import { PerformedBySchema } from '../../performed-by/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
const inputSchema = z.object({
    updateId: z
        .uuid()
        .describe('The applied update to fetch. Obtain via search_updates or search_case_history.'),
});
const outputSchema = z.object({
    updateId: z.uuid(),
    updateTypeId: z.uuid(),
    label: z.string(),
    pausing: z.boolean(),
    important: z.boolean(),
    appliedAt: z.iso.datetime(),
    pausedAt: z.iso.datetime().nullable(),
    continuedAt: z.iso.datetime().nullable(),
    isActive: z.boolean(),
    update: z.string().max(2000).nullable(),
    rolledBack: z.boolean(),
    byWorkflowId: z.uuid().nullable(),
    createdBy: PerformedBySchema.nullable(),
});
export const getUpdateTool = {
    name: ToolName.GetUpdate,
    category: ToolCategory.CaseManagement,
    weight: ToolWeight.Light,
    version: 3,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: "Read one applied update. pausedAt is when it started; continuedAt is when it stopped; isActive means it is currently pausing the case. For the underlying type's cascading procedure, call get_update_type with updateTypeId.",
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-update.js.map